import { PublicOrderActionButton } from '@/components/orders/public-order-action-button';
import { cn } from '@/lib/utils';
import { CheckCircle2, ScanEye } from 'lucide-react';
import { useLocation } from 'wouter';

interface PublicOrderHeaderProps {
  id: string;
  orderNumber?: string | null;
  isLogin?: boolean;
  isPaid?: boolean;
  fullWidth?: boolean;
}

export function PublicOrderHeader({
  orderNumber,
  isLogin,
  id,
  isPaid = false,
  fullWidth = false,
}: PublicOrderHeaderProps) {
  const [, setLocation] = useLocation();

  const handleViewOrder = () => setLocation(`/orders/${id}`);

  return (
    <div className={cn('w-full', !fullWidth && 'max-w-[1400px] mx-auto')}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400 mb-0.5">
            Order Reference
          </p>
          <div className="flex items-center gap-2.5 min-w-0">
            <h1 className="font-black tracking-tight text-slate-900 text-xl sm:text-2xl truncate">
              <span className="text-blue-600">#{orderNumber || 'N/A'}</span>
            </h1>
            {isPaid && (
              <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-100 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-emerald-700 border border-emerald-200">
                <CheckCircle2 className="h-3 w-3" strokeWidth={2.5} />
                PAID
              </span>
            )}
          </div>
        </div>

        {isLogin && (
          <div className="flex flex-wrap items-center gap-2">
            <PublicOrderActionButton
              onClick={handleViewOrder}
              icon={<ScanEye className="w-4 h-4" />}
              label="មើលកម្មង់"
              sub="Details"
            />
          </div>
        )}
      </div>
    </div>
  );
}
